<script>
	import { onMount } from "svelte";
	import { fade } from "svelte/transition";
	import { soundSourcesAll as all, categoryAll } from "../../stores";
	import { Dates } from "../../utils/date";
	import { getResourceUrl } from "../../utils/resource";
	import TableToolbarNoPaging from "../../components/TableToolbarNoPaging.svelte";
	import { menu, menuSub, menuSubSub } from "../../stores";
	import { ErrorCodes } from "../../define/define";
	import { postFileApi, putFileApi, delApi, putApi, postApi } from "../../service/api";
	import {
		getHRLevelText,
		getHRLevelBgColor,
		getHRLevelBorderColor,
		getHRLevelBadgeColor,
		getImageUrl,
		handleImageError,
		ACTIVE_OPTIONS,
		HR_LEVEL_OPTIONS,
		SORT_OPTIONS,
	} from "../../utils/musicCommon";
	import { validateFile, handleImagePreview } from "../../utils/file";
	import { playAudio, stopAudio } from "../../utils/audio";
	import { downloadFile, downloadExcel } from "../../utils/download";

	// 상수 정의
	const BASE_URL = "/sound/sources";
	const SINGLE_URL = "/sound/source";

	// 상태 관리
	let isEditMode = false;
	let editingRowId = null;
	let filteredData = [];
	let currentSort = "updated";
	let currentSortDirection = "asc";
	let searchKeyword = "";

	// 편집 아이템 초기값 - Sound Sources 필드에 맞게 조정
	const defaultEditItem = {
		id: 0,
		idCategorySource: null,
		level: 1,
		subject: "",
		fileName: "",
		musicImage: "",
		isActive: false,
		createdAt: null,
		updatedAt: null,
	};

	// 상세보기 모달 제거로 인해 더 이상 사용하지 않음

	let editItem = { ...defaultEditItem };

	// 모달 상태 관리
	let showModal = false;
	let modalTitle = "";

	// 더 이상 사용하지 않는 상세보기 모달 제거됨

	// 소스장르 데이터
	let categories = [];

	// 소스장르 정보 가져오기
	const loadCategories = async () => {
		await categoryAll.fetch("/contents/category/source");
		categories = $categoryAll.data || [];
		// 활성 소스장르가 있으면 첫 번째 활성 소스장르의 ID를 기본값으로 설정
		// activeCategories는 반응성 구문에서 자동으로 업데이트됨
	};

	// 모달 상태 관리
	let activeCategory = null;

	// 이미지 미리보기 URL 상태
	let imagePreviewUrl = "";

	// 상태 추가
	let audioPlayer = null;
	let isPlaying = false;

	// 상태 추가 - 선택된 파일 관리
	let selectedFiles = {
		image: null,
		audio: null,
	};

	// 상태 추가: 저장 중 여부
	let isSaving = false;

	// 현재 재생 중인 아이템 ID 추적용 상태 추가
	let currentPlayingId = null;

	// 소스장르 관리 모달 관련 상태 추가
	let showCategoryModal = false;
	let isCategorySaving = false;
	let editingCategoryId = null; // 인라인 수정 중인 소스장르 ID
	let editingCategoryData = {}; // 인라인 수정 중인 데이터
	let isNewCategoryMode = false; // 신규 등록 모드
	let newCategoryData = { subject: "", isActive: true }; // idCategorySource 제거 - 단순 소스장르만

	// 입력 핸들러
	const handleInput = (field, value) => {
		if (editItem[field] !== value) {
			editItem[field] = value;
		}
	};

	// 목록에서 음원 재생/정지 핸들러 추가
	const handleListAudioPlay = (item) => {
		if (currentPlayingId === item.id && isPlaying) {
			// 현재 재생 중인 아이템이면 정지
			stopAudio(
				audioPlayer,
				(v) => (audioPlayer = v),
				(v) => (isPlaying = v)
			);
			currentPlayingId = null;
		} else {
			// 기존 재생 중인 음원이 있으면 먼저 정지
			if (isPlaying) {
				stopAudio(
					audioPlayer,
					(v) => (audioPlayer = v),
					(v) => (isPlaying = v)
				);
			}
			// 새로운 음원 재생
			playAudio(
				item.fileName,
				{}, // 목록에서는 업로드된 파일이 아닌 기존 파일을 재생
				(v) => (audioPlayer = v),
				(v) => (isPlaying = v),
				getResourceUrl
			);
			currentPlayingId = item.id;
		}
	};

	// 상세보기 관련 함수들 제거됨 - 이제 편집 모달이 상세 기능을 담당

	// 음원 다운로드 함수
	const handleMusicDownload = () => {
		if (!editItem.fileName) {
			alert("다운로드할 음원 파일이 없습니다.");
			return;
		}

		const fileName = editItem.fileName;
		const subject = editItem.subject || "소스음원";
		const fileExtension = fileName.split(".").pop();
		const customFileName = `${subject}.${fileExtension}`;

		// 커스텀 다운로드 함수
		const fullUrl = getResourceUrl(fileName);
		fetch(fullUrl)
			.then((response) => response.blob())
			.then((blob) => {
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement("a");
				a.href = url;
				a.download = customFileName;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
				document.body.removeChild(a);
			})
			.catch((error) => {
				console.error("다운로드 실패:", error);
				alert("파일 다운로드에 실패했습니다.");
			});
	};

	// 편집 함수
	const fnProcessEdit = (item) => {
		editItem = { ...item };
		modalTitle = '<i class="bx bx-info-circle me-1"></i>소스음원 상세 정보';
		selectedFiles = { image: null, audio: null };
		imagePreviewUrl = "";
		showModal = true;
		setTimeout(() => setFocus("subject"), 100);
	};

	// 삭제 함수
	const fnDelete = async (id) => {
		const item = $all.data.list.find((item) => item.id === id);
		if (item.isActive) {
			alert("노출 중인 소스음원은 삭제할 수 없습니다.");
			return;
		}

		if (confirm("정말 삭제하시겠습니까?")) {
			await delApi(`${SINGLE_URL}/${id}`);
			await fnSearch();
		}
	};

	// 신규 등록 함수
	const fnProcessRegist = () => {
		// 현재 선택된 소스장르가 있으면 그것을 사용, 전체 탭이면 첫 번째 활성 소스장르 사용
		const categoryId = activeCategory !== null ? activeCategory : activeCategories.length > 0 ? activeCategories[0].id : 0;
		editItem = {
			...defaultEditItem,
			idCategorySource: categoryId,
		};
		modalTitle = '<i class="bx bx-plus-circle me-1"></i>소스음원 신규 등록';
		selectedFiles = { image: null, audio: null };
		imagePreviewUrl = "";
		showModal = true;
		setTimeout(() => setFocus("subject"), 100);
	};

	// 서버 적용 함수
	const fnRegistServer = async () => {
		if (confirm("서버에 적용하시겠습니까?\n소스음원 캐시 갱신 작업이 진행됩니다.")) {
			const result = await putApi("/sound/source/cache", {});
			if (result.resultCode === ErrorCodes.OK) {
				alert("서버 적용이 완료되었습니다.");
			} else {
				alert(result.resultDescKo);
			}
		}
	};

	// 메서드
	const setFocus = (field = "subject") => {
		const element = document.getElementById(field);
		if (element) {
			element.focus();
		}
	};

	const validateItem = () => {
		if (!editItem.subject) {
			alert("제목을 입력하세요.");
			setFocus("subject");
			return false;
		}
		if (!editItem.fileName && !selectedFiles.audio) {
			alert("음원 파일을 등록하세요.");
			return false;
		}
		return true;
	};

	// 저장 함수
	const handleSave = async () => {
		if (!validateItem()) return;

		isSaving = true;
		try {
			const formData = new FormData();

			// 기본 필드 추가
			formData.append("id", editItem.id || 0);
			formData.append("idCategorySource", editItem.idCategorySource);
			formData.append("level", editItem.level);
			formData.append("subject", editItem.subject);
			formData.append("isActive", editItem.isActive);

			// 파일 추가 (API 문서에 따라 musicFile로 변경)
			if (selectedFiles.image) {
				formData.append("imageFile", selectedFiles.image);
			}
			if (selectedFiles.audio) {
				formData.append("musicFile", selectedFiles.audio);
			}

			let result;
			if (editItem.id) {
				// 편집
				result = await putFileApi(SINGLE_URL, formData);
			} else {
				// 신규
				result = await postFileApi(SINGLE_URL, formData);
			}

			if (result.resultCode === ErrorCodes.OK) {
				alert(editItem.id ? "수정되었습니다." : "등록되었습니다.");
				closeModal();
				await fnSearch();
			} else {
				alert(result.resultDescKo || "저장 중 오류가 발생했습니다.");
			}
		} catch (error) {
			console.error("Save error:", error);
			alert("저장 중 오류가 발생했습니다.");
		} finally {
			isSaving = false;
		}
	};

	// 모달 닫기
	const closeModal = () => {
		showModal = false;
		resetEdit();
		imagePreviewUrl = "";
		selectedFiles.image = null;
		selectedFiles.audio = null;
		stopAudio(
			audioPlayer,
			(v) => (audioPlayer = v),
			(v) => (isPlaying = v)
		);
		currentPlayingId = null;
		// 파일 input들 초기화
		const imageFile = document.getElementById("imageFile");
		const musicFile = document.getElementById("musicFile");
		if (imageFile) imageFile.value = "";
		if (musicFile) musicFile.value = "";
	};

	// 이미지 선택 취소 핸들러
	const handleCancelImage = () => {
		imagePreviewUrl = "";
		editItem.musicImage = "";
		selectedFiles.image = null;
	};

	const fnSearch = async () => {
		// 검색어가 있을 경우 URL에 포함
		const url = `${BASE_URL}/1000/1/${searchKeyword ? encodeURIComponent(searchKeyword) : "ALL"}`;
		await all.fetch(url);
		resetEdit();
		// 데이터가 로드된 후 필터링 적용
		if ($all?.data) {
			filteredData = getFilteredData($all.data);
		}
	};

	const fnReload = () => {
		searchKeyword = ""; // 검색 키워드 초기화
		currentSort = "updated"; // 정렬 기준 초기화
		currentSortDirection = "asc"; // 정렬 방향 초기화
		fnSearch(); // 데이터 새로 고침
	};

	const resetEdit = () => {
		editItem = { ...defaultEditItem };
		isEditMode = false;
		editingRowId = null;
	};

	// Data processing functions
	const getFilteredData = (data) => {
		if (!data || !data.list) return [];

		let list = data.list;

		// Search filtering
		if (searchKeyword && searchKeyword.trim() !== "") {
			const keyword = searchKeyword.toLowerCase();
			list = list.filter((item) => {
				return item.subject?.toLowerCase().includes(keyword);
			});
		}

		// Category filtering
		if (activeCategory !== null && activeCategory !== undefined) {
			list = list.filter((item) => item.idCategorySource === activeCategory);
		}

		return sortData(list);
	};

	// 정렬 함수
	const sortData = (list) => {
		const sortedList = [...list];
		const direction = currentSortDirection === "asc" ? 1 : -1;

		switch (currentSort) {
			case "updated":
				sortedList.sort((a, b) => direction * (new Date(b.updatedAt) - new Date(a.updatedAt)));
				break;
			case "created":
				sortedList.sort((a, b) => direction * (new Date(b.createdAt) - new Date(a.createdAt)));
				break;
			case "title":
				sortedList.sort((a, b) => direction * a.subject.localeCompare(b.subject));
				break;
			case "category":
				sortedList.sort((a, b) => {
					const catA = getCategoryName(a.idCategorySource);
					const catB = getCategoryName(b.idCategorySource);
					return direction * catA.localeCompare(catB);
				});
				break;
			case "active":
				sortedList.sort((a, b) => {
					const activeA = a.isActive ? 1 : 0;
					const activeB = b.isActive ? 1 : 0;
					return direction * (activeB - activeA);
				});
				break;
			case "level":
				sortedList.sort((a, b) => direction * (b.level - a.level));
				break;
		}

		return sortedList;
	};

	// 반응성 선언
	$: if ($all?.data) {
		filteredData = getFilteredData($all.data);
	}

	// 정렬 변경 시 필터링 데이터 갱신
	$: if (currentSort || currentSortDirection) {
		if ($all?.data) {
			filteredData = getFilteredData($all.data);
		}
	}

	// 소스장르 변경 시 필터링 데이터 갱신
	$: if (activeCategory !== undefined) {
		if ($all?.data) {
			filteredData = getFilteredData($all.data);
		}
	}

	// 소스장르 이름 가져오기 (비활성 소스장르도 표시하되 구분)
	const getCategoryName = (idCategorySource) => {
		const category = categories.find((cat) => cat.id === idCategorySource);
		if (!category) return "소스장르 미지정";
		return category.isActive ? category.subject : `${category.subject} (비활성)`;
	};

	// 반응성 구문 - 활성 소스장르 목록
	$: activeCategories = categories.filter((cat) => cat.isActive);

	// 반응성 구문 - 현재 선택된 소스장르가 비활성이 되면 전체 탭으로 이동
	$: if (activeCategory !== null && !activeCategories.some((cat) => cat.id === activeCategory)) {
		activeCategory = null; // 전체 탭으로 이동
	}

	// 반응성 구문 - 기본 소스장르 ID 설정
	$: if (activeCategories.length > 0) {
		defaultEditItem.idCategorySource = activeCategories[0].id;
	}

	const setActiveCategory = (categoryId) => {
		activeCategory = categoryId;
	};

	// 소스장르 관리 모달 열기
	const openCategoryModal = () => {
		showCategoryModal = true;
	};

	// 소스장르 관리 모달 닫기
	const closeCategoryModal = () => {
		showCategoryModal = false;
		editingCategoryId = null;
		editingCategoryData = {};
	};

	// 신규 소스장르 등록 시작 (인라인)
	const startNewCategory = () => {
		if (isNewCategoryMode) {
			alert("이미 등록 중인 소스장르가 있습니다.");
			return;
		}
		isNewCategoryMode = true;
		newCategoryData = { subject: "", isActive: true };
		// DOM 업데이트 후 포커스 설정
		setTimeout(() => {
			const input = document.getElementById("newCategorySubject");
			if (input) input.focus();
		}, 100);
	};

	// 신규 소스장르 등록 취소
	const cancelNewCategory = () => {
		isNewCategoryMode = false;
		newCategoryData = { subject: "", isActive: true };
	};

	// 신규 소스장르 저장
	const saveNewCategory = async () => {
		if (!newCategoryData.subject.trim()) {
			alert("소스장르명을 입력하세요.");
			return;
		}

		try {
			const result = await postApi("/contents/category/source", {
				subject: newCategoryData.subject,
				isActive: newCategoryData.isActive,
			});

			if (result.resultCode === ErrorCodes.OK) {
				alert("소스장르가 등록되었습니다.");
				isNewCategoryMode = false;
				newCategoryData = { subject: "", isActive: true };
				await loadCategories(); // 소스장르 목록 새로고침
			} else {
				alert(result.resultDescKo || "등록 중 오류가 발생했습니다.");
			}
		} catch (error) {
			console.error("Category save error:", error);
			alert("등록 중 오류가 발생했습니다.");
		}
	};

	// 소스장르 편집 시작 (인라인)
	const startEditCategory = (category) => {
		if (isNewCategoryMode) {
			alert("신규 등록을 완료하거나 취소한 후 수정하세요.");
			return;
		}
		editingCategoryId = category.id;
		editingCategoryData = { ...category };
	};

	// 소스장르 편집 취소 (인라인)
	const cancelEditCategory = () => {
		editingCategoryId = null;
		editingCategoryData = {};
	};

	// 소스장르 편집 저장 (인라인)
	const saveEditCategory = async () => {
		if (!editingCategoryData.subject?.trim()) {
			alert("소스장르명을 입력하세요.");
			return;
		}

		try {
			const result = await putApi("/contents/category/source", {
				id: editingCategoryData.id,
				subject: editingCategoryData.subject,
				isActive: editingCategoryData.isActive,
			});

			if (result.resultCode === ErrorCodes.OK) {
				alert("소스장르가 수정되었습니다.");
				editingCategoryId = null;
				editingCategoryData = {};
				await loadCategories(); // 소스장르 목록 새로고침
			} else {
				alert(result.resultDescKo || "수정 중 오류가 발생했습니다.");
			}
		} catch (error) {
			console.error("Category edit error:", error);
			alert("수정 중 오류가 발생했습니다.");
		}
	};

	// 소스장르 삭제
	const deleteCategoryItem = async (categoryId) => {
		// 소스장르 정보 찾기
		const category = categories.find((cat) => cat.id === categoryId);
		if (!category) {
			alert("소스장르 정보를 찾을 수 없습니다.");
			return;
		}

		// 활성 상태인 소스장르는 삭제 불가
		if (category.isActive) {
			alert("노출 중인 소스장르는 삭제할 수 없습니다.\n먼저 비활성화한 후 삭제하세요.");
			return;
		}

		if (confirm("정말 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.")) {
			try {
				const result = await delApi("/contents/category/source", { id: categoryId });
				if (result.resultCode === ErrorCodes.OK) {
					alert("소스장르가 삭제되었습니다.");
					await loadCategories(); // 소스장르 목록 새로고침
				} else {
					alert(result.resultDescKo || "삭제 중 오류가 발생했습니다.");
				}
			} catch (error) {
				console.error("Category delete error:", error);
				alert("삭제 중 오류가 발생했습니다.");
			}
		}
	};

	// 엑셀 다운로드 함수
	const handleExcelDownload = async () => {
		try {
			// 전체 데이터 가져오기 (검색 필터 제거)
			const url = `${BASE_URL}/10000/1/ALL`; // 충분히 큰 페이지 사이즈로 전체 데이터 조회
			const response = await all.fetch(url);

			if (!$all?.data?.list) {
				alert("다운로드할 데이터가 없습니다.");
				return;
			}

			const allData = $all.data.list;

			// 데이터를 소스장르별로 분류
			const dataByCategory = {};

			// 전체 탭 데이터
			const allExcelData = allData.map((item) => ({
				ID: item.id,
				소스장르: getCategoryName(item.idCategorySource),
				제목: item.subject || "",
				"HR Level": getHRLevelText(item.level),
				음원파일명: item.fileName || "",
				이미지파일명: item.musicImage || "",
				노출여부: item.isActive ? "노출" : "미노출",
				생성일시: item.createdAt ? Dates.defaultConvertFull(item.createdAt) : "",
				수정일시: item.updatedAt ? Dates.defaultConvertFull(item.updatedAt) : "",
			}));

			dataByCategory["전체"] = allExcelData;

			// 소스장르별로 데이터 분류
			categories.forEach((category) => {
				const categoryData = allData
					.filter((item) => item.idCategorySource === category.id)
					.map((item) => ({
						ID: item.id,
						소스장르: category.subject,
						제목: item.subject || "",
						"HR Level": getHRLevelText(item.level),
						음원파일명: item.fileName || "",
						이미지파일명: item.musicImage || "",
						노출여부: item.isActive ? "노출" : "미노출",
						생성일시: item.createdAt ? Dates.defaultConvertFull(item.createdAt) : "",
						수정일시: item.updatedAt ? Dates.defaultConvertFull(item.updatedAt) : "",
					}));

				if (categoryData.length > 0) {
					dataByCategory[category.subject] = categoryData;
				}
			});

			// 미지정 소스장르 데이터
			const unassignedData = allData
				.filter((item) => !categories.find((cat) => cat.id === item.idCategorySource))
				.map((item) => ({
					ID: item.id,
					소스장르: "소스장르 미지정",
					제목: item.subject || "",
					"HR Level": getHRLevelText(item.level),
					음원파일명: item.fileName || "",
					이미지파일명: item.musicImage || "",
					노출여부: item.isActive ? "노출" : "미노출",
					생성일시: item.createdAt ? Dates.defaultConvertFull(item.createdAt) : "",
					수정일시: item.updatedAt ? Dates.defaultConvertFull(item.updatedAt) : "",
				}));

			if (unassignedData.length > 0) {
				dataByCategory["소스장르 미지정"] = unassignedData;
			}

			// 현재 날짜와 시간으로 파일명 생성
			const now = new Date();
			const dateStr = now.toISOString().split("T")[0].replace(/-/g, "");
			const timeStr = now.toTimeString().split(" ")[0].replace(/:/g, "");
			const fileName = `소스음원_${dateStr}_${timeStr}.xlsx`;

			await downloadExcel(dataByCategory, fileName);
		} catch (error) {
			console.error("Excel download error:", error);
			alert("엑셀 다운로드 중 오류가 발생했습니다.");
		}
	};

	onMount(() => {
		menu.set("콘텐츠 관리");
		menuSub.set("음원 관리");
		menuSubSub.set("소스 음원 관리");
		loadCategories();
		fnSearch();
	});
</script>

<div class="card mb-4">
	<div class="p-3">
		<!-- 소스장르 탭 -->
		<ul class="nav nav-tabs d-flex align-items-center" role="tablist" style="min-height: 48px;">
			<li class="nav-item">
				<button
					class="nav-link {!activeCategory ? 'active border-top border-start border-end border-secondary' : ''}"
					style="cursor: pointer; height: 33px; display: flex; align-items: center; font-size: 0.85rem; padding: 0.3rem 0.6rem;"
					on:click={() => setActiveCategory(null)}
				>
					전체 소스음원
				</button>
			</li>
			{#each activeCategories as category}
				<li class="nav-item">
					<button
						class="nav-link {activeCategory === category.id ? 'active border-top border-start border-end border-secondary' : ''}"
						style="cursor: pointer; height: 33px; display: flex; align-items: center; font-size: 0.85rem; padding: 0.3rem 0.6rem;"
						on:click={() => setActiveCategory(category.id)}
					>
						{category.subject}
					</button>
				</li>
			{/each}

			<!-- 소스장르 관리 버튼 추가 -->
			<li class="nav-item">
				<button
					class="nav-link text-primary"
					style="cursor: pointer; height: 33px; display: flex; align-items: center; font-size: 0.85rem; padding: 0.3rem 0.6rem;"
					on:click={openCategoryModal}
					title="소스장르 관리"
				>
					<i class="bx bx-cog" style="font-size: 0.85rem;"></i>
					관리
				</button>
			</li>

			<div class="ms-auto d-flex align-items-center flex-grow-1">
				<div class="d-flex align-items-center flex-grow-1 me-2 justify-content-end">
					<input
						type="text"
						class="form-control form-control-sm me-2"
						placeholder="검색어를 입력하세요"
						style="width: 200px;"
						value={searchKeyword}
						on:input={(e) => (searchKeyword = e.target.value)}
						on:keydown={(e) => {
							if (e.key === "Enter") {
								fnSearch();
							}
						}}
					/>
					<select class="form-select form-select-sm" style="width: auto;" on:change={(e) => (currentSort = e.target.value)}>
						{#each SORT_OPTIONS as option}
							{#if !activeCategory || option.value !== "category"}
								<option value={option.value} selected={currentSort === option.value}>
									{option.text}
								</option>
							{/if}
						{/each}
					</select>
				</div>
				<div class="btn-group me-2">
					<button
						type="button"
						class="btn btn-sm {currentSortDirection === 'asc' ? 'btn-primary' : 'btn-outline-primary'}"
						title="오름차순"
						on:click={() => (currentSortDirection = "asc")}
					>
						<i class="bx bx-sort-up"></i>
					</button>
					<button
						type="button"
						class="btn btn-sm {currentSortDirection === 'desc' ? 'btn-primary' : 'btn-outline-primary'}"
						title="내림차순"
						on:click={() => (currentSortDirection = "desc")}
					>
						<i class="bx bx-sort-down"></i>
					</button>
				</div>
				<TableToolbarNoPaging onReload={fnReload} onRegist={fnProcessRegist} onRegistServer={fnRegistServer} />
				<button type="button" class="btn btn-sm btn-warning me-1" on:click={handleExcelDownload} title="엑셀 다운로드">
					<i class="bx bx-download me-1"></i>
					엑셀
				</button>
			</div>
		</ul>

		<!-- 카드 뷰 컨테이너 -->
		{#if filteredData.length === 0}
			<div class="text-center p-5">
				<i class="bx bx-info-circle fs-1 text-muted"></i>
				<p class="text-muted mt-3">데이터가 없습니다.</p>
			</div>
		{:else}
			<div class="row g-3 mt-3" style="display: flex; flex-wrap: wrap;">
				{#each filteredData as item, i (item.id)}
					<!-- 일반 카드 -->
					<div style="width: 200px; margin-bottom: 0.5rem; padding: 0 0.5rem;" in:fade={{ duration: 300, delay: i * 20 }}>
						<div class="card h-100 border border-opacity-50">
							<div class="position-relative">
								{#if item.musicImage}
									<div style="height: 130px; overflow: hidden;">
										<img
											src={item.musicImage}
											alt={item.subject}
											class="w-100 h-100 card-img-top"
											style="object-fit: cover; height: 130px;"
											on:error={handleImageError}
										/>
									</div>
								{:else}
									<div style="height: 130px; overflow: hidden;">
										<img
											src="/assets/img/nope-not-here.avif"
											alt="이미지 없음"
											style="width: 220px; height: 130px; object-fit: cover;"
										/>
									</div>
								{/if}
								<!-- 배지를 이미지 위에 겹쳐서 표시 -->
								<div class="position-absolute top-0 start-0 p-2 d-flex justify-content-between w-100">
									<span class="badge {item.isActive ? 'bg-primary text-white' : 'bg-secondary text-dark'} fw-bold">
										{item.isActive ? "노출" : "미노출"}
									</span>
									<span class="badge {getHRLevelBadgeColor(item.level)}">
										{getHRLevelText(item.level)}
									</span>
								</div>
							</div>
							<div class="card-body p-2">
								<h6 class="card-title mb-1">
									{item.subject}
								</h6>
								<div class="mt-2">
									<p class="card-text mb-0 small">
										소스장르: {getCategoryName(item.idCategorySource)}
									</p>
								</div>
							</div>
							<div class="card-footer d-flex justify-content-end align-items-center p-2 bg-light">
								<div class="input-group justify-content-end">
									<!-- 재생 버튼 -->
									{#if item.fileName}
										<button
											class="btn btn-sm btn-outline-primary"
											on:click={() => handleListAudioPlay(item)}
											title={currentPlayingId === item.id && isPlaying ? "정지" : "재생"}
										>
											<i class="bx {currentPlayingId === item.id && isPlaying ? 'bx-stop' : 'bx-play'}"></i>
										</button>
									{/if}
									<button class="btn btn-sm btn-primary" on:click={() => fnProcessEdit(item)}>상세</button>
									<button class="btn btn-sm btn-outline-primary" on:click={() => fnDelete(item.id)}>삭제</button>
								</div>
							</div>
						</div>
					</div>
				{/each}
			</div>
		{/if}
	</div>
</div>

<!-- 편집/등록 모달 -->
{#if showModal}
	<div
		class="modal fade {showModal ? 'show' : ''}"
		style="display: block;"
		tabindex="-1"
		aria-modal="true"
		role="dialog"
		transition:fade={{ duration: 200 }}
	>
		<div class="modal-dialog modal-dialog-centered modal-lg">
			<div class="modal-content">
				<div class="modal-header {!editItem.id ? 'bg-light' : ''}">
					<h5 class="modal-title d-flex align-items-center">
						{@html modalTitle}
					</h5>
					<button type="button" class="btn-close" on:click={closeModal}></button>
				</div>
				<div class="modal-body">
					<!-- 기본 정보 -->
					<div class="mb-4">
						<h6 class="border-bottom pb-2 mb-3 d-flex align-items-center bg-light p-2 rounded">
							<i class="bx bx-info-circle me-2"></i>
							기본 정보
						</h6>
						<div class="row">
							<div class="col-md-6">
								<div class="mb-3">
									<label for="idCategorySource" class="form-label">소스장르</label>
									<select
										class="form-select form-select-sm"
										id="idCategorySource"
										value={editItem.idCategorySource}
										on:change={(e) => handleInput("idCategorySource", parseInt(e.target.value))}
									>
										{#each categories as category}
											<option
												value={category.id}
												disabled={!category.isActive && (!editItem.id || editItem.idCategorySource !== category.id)}
											>
												{category.subject} ({category.id}) {!category.isActive ? "(비활성)" : ""}
											</option>
										{/each}
									</select>
								</div>
							</div>
							<div class="col-md-6">
								<div class="mb-3">
									<label for="level" class="form-label">HR Level</label>
									<select
										class="form-select form-select-sm"
										id="level"
										value={editItem.level}
										on:change={(e) => handleInput("level", parseInt(e.target.value))}
									>
										{#each HR_LEVEL_OPTIONS as option}
											<option value={option.value}>{option.text}</option>
										{/each}
									</select>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="mb-3">
									<label for="subject" class="form-label">제목</label>
									<input
										type="text"
										class="form-control form-control-sm"
										id="subject"
										value={editItem.subject}
										on:input={(e) => handleInput("subject", e.target.value)}
										placeholder="소스음원 제목을 입력하세요"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- 리소스 정보 -->
					<div class="mb-4">
						<h6 class="border-bottom pb-2 mb-3 d-flex align-items-center bg-light p-2 rounded">
							<i class="bx bx-file me-2"></i>
							리소스 정보
						</h6>
						<div class="row">
							<div class="col-md-6">
								<div class="mb-3">
									<label for="musicImage" class="form-label">이미지 파일</label>
									<div class="input-group input-group-sm">
										<input
											type="text"
											class="form-control form-control-sm"
											id="musicImage"
											value={editItem.musicImage}
											readOnly
											on:click={() => document.getElementById("imageFile").click()}
											placeholder="이미지 파일을 선택하세요"
										/>
										<label class="input-group-text" for="imageFile">
											<i class="bx bx-upload"></i>
										</label>
										<input
											type="file"
											id="imageFile"
											accept="image/*"
											class="d-none"
											on:change={(e) => {
												const file = e.target.files[0];
												if (file && validateFile(file, "image")) {
													selectedFiles.image = file;
													handleImagePreview(file, (url) => {
														imagePreviewUrl = url;
													});
													editItem.musicImage = file.name;
												}
											}}
										/>
									</div>
									<small class="text-muted mt-1">
										<i class="bx bx-info-circle me-1"></i>
										해당 이미지는 모든 음원에 공통으로 사용됩니다.
									</small>
								</div>
							</div>
							<div class="col-md-6">
								<div class="mb-3">
									<label for="fileName" class="form-label">음원 파일</label>
									<div class="input-group input-group-sm">
										<input
											type="text"
											class="form-control form-control-sm"
											id="fileName"
											value={editItem.fileName}
											readOnly
											on:click={() => document.getElementById("musicFile").click()}
											placeholder="음원 파일을 선택하세요"
										/>
										{#if editItem.fileName}
											<button
												type="button"
												class="btn btn-sm {isPlaying ? 'btn-danger' : 'btn-primary'}"
												title={isPlaying ? "중지" : "재생"}
												on:click={() =>
													isPlaying
														? stopAudio(
																audioPlayer,
																(v) => (audioPlayer = v),
																(v) => (isPlaying = v)
															)
														: playAudio(
																editItem.fileName,
																selectedFiles,
																(v) => (audioPlayer = v),
																(v) => (isPlaying = v),
																getResourceUrl
															)}
											>
												<i class="bx {isPlaying ? 'bx-stop' : 'bx-play'}"></i>
											</button>
										{/if}
										<label class="input-group-text" style="cursor: pointer;" for="musicFile">
											<i class="bx bx-upload"></i>
										</label>
										<input
											type="file"
											id="musicFile"
											accept="audio/*,.mp3,.wav,.aac,.m4a,.ogg,.flac"
											class="d-none"
											on:change={(e) => {
												const file = e.target.files[0];
												if (file && validateFile(file, "audio")) {
													selectedFiles.audio = file;
													editItem.fileName = file.name;
												}
											}}
										/>
									</div>
									<div class="mt-1">
										<small class="text-muted d-block">
											<i class="bx bx-info-circle me-1"></i>
											파일명은 서버에서 자동으로 UUID로 할당됩니다.
										</small>
										<small class="text-muted d-block">
											<i class="bx bx-info-circle me-1"></i>
											해당 음원은 모든 소스장르에 공통으로 사용됩니다.
										</small>
									</div>
									<!-- 음원 다운로드 버튼을 여기로 이동 -->
									{#if editItem.fileName && editItem.id}
										<div class="mt-2">
											<button type="button" class="btn btn-outline-primary btn-sm" on:click={handleMusicDownload}>
												<i class="bx bx-download me-1"></i>
												음원 다운로드
											</button>
										</div>
									{/if}
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="mt-2">
									{#if imagePreviewUrl}
										<div class="mb-2">
											<p class="small text-muted mb-1">선택한 이미지 미리보기:</p>
											<div class="position-relative d-inline-block">
												<img src={imagePreviewUrl} alt="선택한 이미지" class="img-thumbnail" style="max-height: 150px;" />
												<button
													type="button"
													class="btn btn-sm btn-danger position-absolute top-0 end-0 rounded-circle p-0 m-1"
													style="width: 20px; height: 20px; line-height: 1; font-size: 14px;"
													title="선택 취소"
													on:click={handleCancelImage}
												>
													<i class="bx bx-x"></i>
												</button>
											</div>
										</div>
									{:else if editItem.musicImage && editItem.id}
										<p class="small text-muted mb-1">현재 이미지:</p>
										<div class="position-relative d-inline-block">
											<img
												src={editItem.musicImage}
												alt="미리보기"
												class="img-thumbnail"
												style="max-height: 150px;"
												on:error={handleImageError}
											/>
										</div>
									{/if}
								</div>
							</div>
						</div>
					</div>

					<!-- 노출여부 -->
					<div class="mb-4">
						<h6 class="border-bottom pb-2 mb-3 d-flex align-items-center bg-light p-2 rounded">
							<i class="bx bx-cog me-2"></i>
							설정
						</h6>
						<div class="row">
							<div class="col-12">
								<div class="mb-3">
									<div class="form-check form-switch">
										<input class="form-check-input" type="checkbox" id="isActive" bind:checked={editItem.isActive} />
										<label class="form-check-label" for="isActive">노출 여부</label>
									</div>
								</div>
							</div>
						</div>
					</div>

					{#if editItem.id}
						<div class="mb-4">
							<h6 class="border-bottom pb-2 mb-3 d-flex align-items-center bg-light p-2 rounded">
								<i class="bx bx-info-circle me-2"></i>
								시스템 정보
							</h6>
							<small class="text-muted">생성: {editItem.createdAt ? Dates.defaultConvertFull(editItem.createdAt) : "알 수 없음"}</small>
							<br />
							<small class="text-muted">수정: {editItem.updatedAt ? Dates.defaultConvertFull(editItem.updatedAt) : "알 수 없음"}</small>
						</div>
					{/if}
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm me-1" on:click={handleSave} disabled={isSaving}>
						{#if isSaving}
							<i class="bx bx-loader-alt bx-spin me-1"></i>
						{/if}
						저장
					</button>
					<button type="button" class="btn btn-outline-secondary btn-sm" on:click={closeModal}>취소</button>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-backdrop fade {showModal ? 'show' : ''}" transition:fade={{ duration: 200 }}></div>
{/if}

<!-- 소스장르 관리 모달 -->
{#if showCategoryModal}
	<div
		class="modal fade {showCategoryModal ? 'show' : ''}"
		style="display: block;"
		tabindex="-1"
		aria-modal="true"
		role="dialog"
		transition:fade={{ duration: 200 }}
	>
		<div class="modal-dialog modal-dialog-centered modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-light">
					<h5 class="modal-title d-flex align-items-center">
						<i class="bx bx-cog me-2"></i>
						소스장르 관리
					</h5>
					<button type="button" class="btn-close" on:click={closeCategoryModal}></button>
				</div>
				<div class="modal-body">
					<!-- 소스장르 목록 -->
					<div class="card">
						<div class="card-header bg-light d-flex justify-content-between align-items-center">
							<h6 class="mb-0 d-flex align-items-center">
								<i class="bx bx-list-ul me-2"></i>
								소스장르 관리
							</h6>
							<button class="btn btn-primary btn-sm" on:click={startNewCategory} disabled={isNewCategoryMode}>
								<i class="bx bx-plus me-1"></i>
								소스장르 등록
							</button>
						</div>
						<div class="card-body p-0">
							{#if categories.length === 0 && !isNewCategoryMode}
								<div class="text-center p-4">
									<i class="bx bx-info-circle fs-1 text-muted"></i>
									<p class="text-muted mt-2">등록된 소스장르가 없습니다.</p>
								</div>
							{:else}
								<div class="table-responsive">
									<table class="table table-hover mb-0">
										<thead class="table-light">
											<tr class="text-center">
												<th style="width: 70px;">ID</th>
												<th>소스장르명</th>
												<th style="width: 80px;">노출여부</th>
												<th style="width: 130px;">생성일</th>
												<th style="width: 130px;">수정일</th>
												<th style="width: 110px;">관리</th>
											</tr>
										</thead>
										<tbody>
											<!-- 신규 등록 행 -->
											{#if isNewCategoryMode}
												<tr class="table-info text-center">
													<td class="align-middle">
														<span class="badge bg-info">NEW</span>
													</td>
													<td>
														<!-- 소스장르명 입력 -->
														<input
															type="text"
															class="form-control form-control-sm text-center"
															id="newCategorySubject"
															placeholder="소스장르명을 입력하세요"
															bind:value={newCategoryData.subject}
															on:keydown={(e) => {
																if (e.key === "Enter") saveNewCategory();
																if (e.key === "Escape") cancelNewCategory();
															}}
														/>
													</td>
													<td>
														<div class="form-check form-switch d-flex justify-content-center">
															<input class="form-check-input" type="checkbox" bind:checked={newCategoryData.isActive} />
														</div>
													</td>
													<td>
														<small class="text-muted">-</small>
													</td>
													<td>
														<small class="text-muted">-</small>
													</td>
													<td>
														<div class="btn-group">
															<button class="btn btn-sm btn-primary" on:click={saveNewCategory} title="저장">
																<i class="bx bx-check"></i>
															</button>
															<button
																class="btn btn-sm btn-outline-secondary"
																on:click={cancelNewCategory}
																title="취소"
															>
																<i class="bx bx-x"></i>
															</button>
														</div>
													</td>
												</tr>
											{/if}

											<!-- 기존 소스장르 목록 -->
											{#each categories as category}
												<tr class="text-center">
													<td>{category.id}</td>
													<td>
														{#if editingCategoryId === category.id}
															<!-- 편집 모드 -->
															<input
																type="text"
																class="form-control form-control-sm"
																bind:value={editingCategoryData.subject}
																on:keydown={(e) => {
																	if (e.key === "Enter") saveEditCategory();
																	if (e.key === "Escape") cancelEditCategory();
																}}
															/>
														{:else}
															<!-- 보기 모드 -->
															<strong>{category.subject}</strong>
														{/if}
													</td>
													<td>
														{#if editingCategoryId === category.id}
															<div class="form-check form-switch d-flex justify-content-center">
																<input
																	class="form-check-input"
																	type="checkbox"
																	bind:checked={editingCategoryData.isActive}
																/>
															</div>
														{:else}
															<span class="badge {category.isActive ? 'bg-primary' : 'bg-secondary'}">
																{category.isActive ? "활성" : "비활성"}
															</span>
														{/if}
													</td>
													<td>
														<small class="text-muted">
															{category.createdAt ? Dates.defaultConvertFull(category.createdAt) : "-"}
														</small>
													</td>
													<td>
														<small class="text-muted">
															{category.updatedAt ? Dates.defaultConvertFull(category.updatedAt) : "-"}
														</small>
													</td>
													<td>
														{#if editingCategoryId === category.id}
															<div class="btn-group">
																<button class="btn btn-sm btn-primary" on:click={saveEditCategory} title="저장">
																	<i class="bx bx-check"></i>
																</button>
																<button
																	class="btn btn-sm btn-outline-secondary"
																	on:click={cancelEditCategory}
																	title="취소"
																>
																	<i class="bx bx-x"></i>
																</button>
															</div>
														{:else}
															<div class="btn-group">
																<button
																	class="btn btn-sm btn-outline-primary"
																	on:click={() => startEditCategory(category)}
																	title="편집"
																	disabled={isNewCategoryMode}
																>
																	<i class="bx bx-edit"></i>
																</button>
																<button
																	class="btn btn-sm btn-outline-secondary"
																	on:click={() => deleteCategoryItem(category.id)}
																	title={category.isActive ? "노출 중인 소스장르는 삭제할 수 없습니다" : "삭제"}
																	disabled={isNewCategoryMode || category.isActive}
																>
																	<i class="bx bx-trash"></i>
																</button>
															</div>
														{/if}
													</td>
												</tr>
											{/each}
										</tbody>
									</table>
								</div>
							{/if}
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-sm btn-outline-secondary" on:click={closeCategoryModal}>닫기</button>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-backdrop fade {showCategoryModal ? 'show' : ''}" transition:fade={{ duration: 200 }}></div>
{/if}

<style>
	.cursor-pointer {
		cursor: pointer;
	}

	.text-truncate {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		max-width: 100%;
	}
</style>
